var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "badge",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.bottom",
          value: _vm.status.description,
          expression: "status.description",
          modifiers: { bottom: true },
        },
      ],
      staticClass: "m-0 badge-notification sync-badge-status",
      class: {
        "sync-badge-status-loading": _vm.isSyncLoadingStatus,
        "sync-badge-status-error": _vm.isSyncErrorStatus,
      },
      attrs: { type: _vm.status.type },
    },
    [_vm._v("\n  " + _vm._s(_vm.status.message) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }